module.exports = __webpack_public_path__ + "img/pumpkin.01ad9cc3.svg";